import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({ family: 'OpenSans', src: 'https://www.zillowstatic.com/static/fonts/OpenSans-Regular-webfont.ttf' });
Font.register({ family: 'OpenSansBold', src: 'https://www.zillowstatic.com/static/fonts/OpenSans-Bold-webfont.ttf' });
Font.register({
  family: 'VollkornBold',
  src: 'https://www.zillowstatic.com/static-zsg/LATEST/static-zsg/zsg/z-fonts/ivar/IvarHeadline-SemiBold-core.woff',
});

const styles = StyleSheet.create({
  // typography
  pageHeading: {
    fontFamily: 'VollkornBold',
    fontSize: 24,
  },
  heading: {
    fontFamily: 'OpenSansBold',
    fontSize: 20,
  },
  subHeading: {
    fontFamily: 'OpenSansBold',
    fontSize: 16,
  },
  bodyHeading: {
    fontSize: 10,
    fontFamily: 'OpenSansBold',
    paddingBottom: 4,
  },
  body: {
    fontSize: 16,
    fontFamily: 'OpenSans',
    paddingBottom: 4,
  },
  footerHeading: {
    fontFamily: 'OpenSansBold',
    fontSize: '8px',
  },
  footerText: {
    fontFamily: 'OpenSans',
    fontSize: '8px',
  },

  // spacing
  marginBottomSm: {
    marginBottom: 16,
  },
  marginAuto: {
    margin: 'auto',
  },
  flexRow: {
    flexDirection: 'row',
  },
  flexColumn: {
    flexDirection: 'column',
  },

  // containers
  page: {
    backgroundColor: '#FFFFFF',
  },
  containerBase: {
    paddingHorizontal: '20px',
    paddingVertical: '10px',
  },
  paymentSummary: {
    width: '100%',
    padding: '20px',
    backgroundColor: '#f9f9fb',
  },
  right: {
    position: 'absolute',
    right: 8,
    top: 8,
  },
  columnStyle: {
    flexDirection: 'column',
    width: '20%',
    fontSize: 8,
  },
  summaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

export default styles;
